import { Rocket, LogIn, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const FooterCta = () => {
  const navigate = useNavigate();
  return (
    <footer data-testid="footer" className="bg-brutal-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: "repeating-linear-gradient(45deg, #FFEC3D 0 2px, transparent 2px 28px)" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-24 sm:py-32 text-center">
        <div className="inline-flex items-center gap-2 bg-brutal-yellow border-[2.5px] border-brutal-black px-3.5 py-1.5 shadow-brutal-xs">
          <Sparkles size={14} strokeWidth={3} className="text-brutal-black" />
          <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-brutal-black">COMECE AGORA</span>
        </div>
        <h2 className="mt-7 font-heading text-4xl sm:text-5xl lg:text-7xl tracking-tight text-white uppercase max-w-4xl mx-auto leading-[0.95]">
          Pronto pra modernizar<br />seu restaurante{" "}
          <span className="bg-brutal-pink border-[3px] border-white text-white px-3 py-0.5 inline-block shadow-[8px_8px_0_0_#FFEC3D] -rotate-1 mt-2">sem complicação?</span>
        </h2>
        <p className="mt-7 text-white/90 text-base sm:text-lg max-w-xl mx-auto font-medium">
          Crie sua conta agora, monte seu cardápio em minutos e comece a receber pedidos ainda esta semana.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center items-center">
          <button data-testid="footer-register-cta" onClick={() => navigate("/login", { state: { register: true } })} className="bg-brutal-yellow text-brutal-black border-[3px] border-white px-10 py-5 font-heading uppercase tracking-tight text-lg shadow-[8px_8px_0_0_#FF4D8D] hover:translate-y-[-4px] hover:shadow-[12px_12px_0_0_#FF4D8D] active:translate-y-[2px] active:shadow-[4px_4px_0_0_#FF4D8D] transition-all inline-flex items-center gap-3">
            <Rocket size={22} strokeWidth={3} />Criar conta grátis
          </button>
          <button data-testid="footer-login-cta" onClick={() => navigate("/login")} className="bg-transparent text-white border-[3px] border-white px-8 py-5 font-heading uppercase tracking-tight text-base hover:bg-white hover:text-brutal-black transition-all inline-flex items-center gap-2">
            <LogIn size={20} strokeWidth={3} />Já tenho conta
          </button>
        </div>
      </div>
      <div className="relative border-t-[3px] border-brutal-yellow">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <img src="/logo-pedefacil.jpg" alt="Pede é Fácil" className="h-9 w-9 border-[2.5px] border-brutal-yellow object-cover" />
            <p className="font-heading text-lg text-white uppercase">Pede<span className="text-brutal-yellow"> é </span>Fácil</p>
          </div>
          <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-white/60">
            © 2026 CARDÁPIO DIGITAL COM IA
          </p>
        </div>
      </div>
    </footer>
  );
};
